import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { getEntities as getAidasObjects } from 'app/entities/ainnotateservice/aidas-object/aidas-object.reducer';
import { IAidasProperties } from 'app/shared/model/ainnotateservice/aidas-properties.model';
import { getEntities as getAidasProperties } from 'app/entities/ainnotateservice/aidas-properties/aidas-properties.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-object-property.reducer';
import { IAidasObjectProperty } from 'app/shared/model/ainnotateservice/aidas-object-property.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasObjectPropertyUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasObjects = useAppSelector(state => state.aidasObject.entities);
  const aidasProperties = useAppSelector(state => state.aidasProperties.entities);
  const aidasObjectPropertyEntity = useAppSelector(state => state.aidasObjectProperty.entity);
  const loading = useAppSelector(state => state.aidasObjectProperty.loading);
  const updating = useAppSelector(state => state.aidasObjectProperty.updating);
  const updateSuccess = useAppSelector(state => state.aidasObjectProperty.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-object-property' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasObjects({}));
    dispatch(getAidasProperties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasObjectPropertyEntity,
      ...values,
      aidasObject: aidasObjects.find(it => it.id.toString() === values.aidasObjectId.toString()),
      aidasProperties: aidasProperties.find(it => it.id.toString() === values.aidasPropertiesId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasObjectPropertyEntity,
          aidasObjectId: aidasObjectPropertyEntity?.aidasObject?.id,
          aidasPropertiesId: aidasObjectPropertyEntity?.aidasProperties?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="ainnotategwApp.ainnotateserviceAidasObjectProperty.home.createOrEditLabel"
            data-cy="AidasObjectPropertyCreateUpdateHeading"
          >
            Create or edit a AidasObjectProperty
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="aidas-object-property-id" label="ID" validate={{ required: true }} />
              ) : null}

              <ValidatedField
                id="aidas-object-property-aidasObject"
                name="aidasObjectId"
                data-cy="aidasObject"
                label="Aidas Object"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasObjects
                  ? aidasObjects.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <ValidatedField
                id="aidas-object-property-aidasProperties"
                name="aidasPropertiesId"
                data-cy="aidasProperties"
                label="Aidas Properties"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasProperties
                  ? aidasProperties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <ValidatedField label="Value" id="aidas-object-property-value" name="value" data-cy="value" type="text" />

              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-object-property" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasObjectPropertyUpdate;
